<template>
  <div class="description">
    <div v-if="linkedModels?.length" class="linked-model">
      <UiLinkedModel
        v-for="(item, index) in linkedModels"
        :key="`builtInMemory_${index}`"
        :add-filter-query="filterQuery"
        :data="item"
        :class="index === linkedModels?.length - 1 ? 'last' : ''"
      />
    </div>
    <div
      v-if="showPreloaderLinkedModel"
      class="preload-block-wrapper empty-linked-model"
    >
      <span class="preload-block-api" />
    </div>
    <div class="text_specifications">
      <div v-if="isSpecifications > 0" class="header heading-xs">О товаре</div>
      <template v-if="isSpecifications">
        <div
          v-if="isSpecifications"
          data-copy="for-copied"
          class="specifications-block"
        >
          <template v-for="(item, index) in pageData.baseSpec.specifications">
            <dl
              v-if="index < 13"
              :key="`specifications_row_${index}`"
              class="specifications_row"
            >
              <dt class="specifications_title body-m-regular">
                <span>{{ item.title }}</span>
              </dt>
              <dd class="specifications_value">
                <nuxt-link
                  v-if="item.link"
                  class="link"
                  target="_blank"
                  :to="item.link"
                >
                  <RenderHTML
                    tag-wrapper="span"
                    :seotext="textSpace(item.value)"
                  />
                </nuxt-link>
                <RenderHTML
                  v-else
                  tag-wrapper="span"
                  :seotext="textSpace(item.value)"
                />
              </dd>
            </dl>
          </template>
        </div>
        <ui-ui-link
          v-if="isSpecifications"
          size="medium"
          :font-weight="400"
          @click="$emit('to-route', 'specifications')"
        >
          Все характеристики
        </ui-ui-link>
      </template>
      <div
        v-if="showPreloaderDescriptionBase"
        class="preload-block-wrapper empty-linked-model"
      >
        <span class="preload-block-api" />
      </div>
    </div>
    <div v-if="showDescription && description" class="description-model">
      <PageModelDescriptionModel :seo-data="seoData" />
    </div>
    <div
      v-if="isRelatedProducts"
      class="description-block body-m-regular color-link"
      @click="showMmodelSimilar"
    >
      Похожие товары
    </div>
    <div v-if="isRelatedProducts" class="description-block body-m-regular">
      <ui-ui-link size="medium" :font-weight="400" @click="showMmodelSimilar">
        Похожие товары
      </ui-ui-link>
    </div>
  </div>
</template>

<script lang="ts" setup>
import RenderHTML from '~/components/ui/RenderHTML.vue';

const props = defineProps({
  pageData: {
    type: Object as any,
    required: true,
  },
  seoData: {
    type: Object as any,
    required: true,
  },
  isLessDesktop: {
    type: Boolean,
    required: false,
  },
  showPreloaderLinkedModel: {
    type: Boolean,
    required: true,
  },
  showPreloaderDescriptionBase: {
    type: Boolean,
    required: true,
  },
  filterQuery: {
    type: String,
    default: '',
  },
});
const emit = defineEmits(['to-route', 'go-to']);
const linkedModels = computed(() => props.pageData?.linkedModels);
const description = computed(() => props.seoData?.page?.text);
const isRelatedProducts = computed(
  () => props.pageData?.baseSpec?.show_presets_anchor_in_modelcard
);
const isSpecifications = computed(
  () => props.pageData?.baseSpec?.specifications?.length
);

const showDescription = computed(
  () => props.pageData?.baseSpec?.show_description_in_modelcard
);
const textSpace = (text: string) => {
  return text.replace(/\+/g, '&#8203;+&#8203;');
};
const showMmodelSimilar = () => {
  emit('go-to', 'model-similar');
};
</script>
<style lang="scss" scoped>
.description {
  width: 100%;
  @include xl-block {
    width: 50%;
    padding-left: 16px;
  }
  @include xxl-block {
    width: 57.14%;
    padding: 0 16px;
  }

  .linked-model {
    @include lg-block {
      margin-bottom: 20px;
    }
  }
}

.mobile-specifications {
  display: block;
  margin-bottom: 20px;
  @include md-block {
    display: none;
  }
}

.text_specifications {
  width: 100%;
  display: none;
  @include xl-block {
    display: block;
  }

  .header {
    margin-bottom: 12px;
  }

  .specifications-block {
    padding-bottom: 12px;

    .specifications_row {
      display: flex;
      width: 100%;
      align-items: flex-end;

      &:not(:last-child) {
        margin-bottom: 12px;
      }

      span {
        align-items: flex-end;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
      }

      .specifications_title {
        position: relative;
        overflow: hidden;
        width: 50%;
        line-height: 16px;
        padding-right: 16px;
        display: none;

        &:before {
          border-bottom: 1px dashed $gray3;
          bottom: 4px;
          content: '';
          display: block;
          left: 0;
          position: absolute;
          width: 100%;
        }

        span {
          padding-right: 2px;
          display: inline;
          position: relative;
          color: $achromatic-disabled;
          background-color: white;
        }

        @include xl-block {
          display: block;
          padding-right: 0;
        }
      }

      .specifications_value {
        padding-left: 2px;
        overflow: hidden;
        line-height: 16px;
        width: 50%;
        color: $achromatic-black;
      }
    }
  }
}

.description-block {
  margin-top: 20px;
  padding-right: 44px;
}

.description-block__title {
  margin-bottom: 8px;
  color: $achromatic-black;
}

.description-block__link {
  margin-top: 8px;
}

.description-model {
  margin-top: 20px;
  max-width: 498px;
  display: none;
  @include xl-block {
    display: block;
  }

  //:deep(h2) {
  //  text-transform: unset;
  //  font-size: 14px;
  //  font-weight: 600;
  //  line-height: 20px;
  //  margin-bottom: 8px;
  //}

  //:deep(.block-text-description) {
  //  font-size: 14px;
  //  font-weight: 400;
  //  line-height: 20px;
  //
  //  &.block-text-description--collapsed {
  //    max-height: 138px;
  //
  //    &:after {
  //      display: none;
  //    }
  //  }
  //
  //  p,
  //  ul {
  //    margin: 0;
  //  }
  //}
  //
  //:deep(.more-link) {
  //  font-size: 14px;
  //  font-weight: 400;
  //  line-height: 20px;
  //
  //  &:after {
  //    display: none;
  //  }
  //}
}

.empty-linked-model {
  height: 240px;
}
</style>
